import { RouteObject } from "react-router-dom";
import OrganizerManage from "./OrganizerManage";
import OrganizerDetailManage from "./OrganizerDetailManage";
import AuthGuardWrapper from "../../auth/AuthGuardWrapper";
import { FootballOrganizer } from "../../../commons/models/football/football-organizer";

export const routerAdminOrganizer: RouteObject[] = [
  {
    path: "",
    element: (
      <AuthGuardWrapper subject={FootballOrganizer}>
        <OrganizerManage />
      </AuthGuardWrapper>
    ),
  },
  {
    path: ":organizerId",
    element: (
      <AuthGuardWrapper subject={FootballOrganizer}>
        <OrganizerDetailManage />
      </AuthGuardWrapper>
    ),
  },
];
